// Imports
import { createSlice } from '@reduxjs/toolkit';
import { SliceNames, DefaultSliceData } from "../config/Constants";

// Slice state
interface NavData {
  orderId?: number;
}
interface NavSelectionSliceState {
  index: number;
  navData: NavData
}

// Create slice
export const navSelectionSlice = createSlice({
  name: SliceNames.NAV_SELECTION_INDEX,
  initialState: {
    index: DefaultSliceData.NAV_SELECTION_INDEX,
    navData: {}
  },
  reducers: {
    setNavSelection(state: NavSelectionSliceState, action) {
      state.index = action.payload;
    },
    setNavData(state: NavSelectionSliceState, action: { payload: NavData, type: string }) {
      state.navData = action.payload;
    }
  }
});

// Export state actions for this slice
export const { setNavSelection, setNavData } = navSelectionSlice.actions;

// Export state getters for this slice
export const getNavSelection = (state: any) => state[SliceNames.NAV_SELECTION_INDEX].index;
export const getNavData = (state: any) => state[SliceNames.NAV_SELECTION_INDEX].navData;

// Export reducer
export const navSelectionReducer = navSelectionSlice.reducer;